<template>
  <div class="dflexc-jcs encounter-view-panel">
  <TerrainSelectPanel
    @generate="fetchEncounter"
  />
    <EncounterCard :enc="encounter"/>

  </div>

</template>

<style scoped lang="scss">
@import "@/assets/styles/colors";
@import "@/assets/styles/encounter-view-panel";

.debug {
  color: bisque;
}
</style>

<script setup>
import TerrainSelectPanel from '@/components/encounter/terrain_select_panel.vue'
import {EncounterService} from "@/services/encounter_service";
import EncounterCard from "@/components/encounter/encounter_card.vue"
import {reactive} from "vue";

const encService = new EncounterService()

const encounter = reactive({})


const fetchEncounter = async (tgrp, ter_act) => {
  const enc = await encService.generate(tgrp, ter_act)
  console.log('Encounter fetched:', enc)
  Object.assign(encounter, enc)
}


</script>
